import {useRef, useEffect} from 'react';

const useFocusOut = (onFocusOut, conditional) => {
  const internalFocusRef = useRef();
  const handleFocus = (e) => {
    if (internalFocusRef.current && !internalFocusRef.current.contains(e.target)) {
      onFocusOut(e);
    }
  };

  useEffect(() => {
    /**
     * We only need to track focus based on this conditional.
     * Let's not start earlier.
     **/
    if (conditional !== undefined) {
      if (conditional) {
        document.addEventListener('focus', handleFocus, true);
      } else {
        document.removeEventListener('focus', handleFocus, true);
      }
    } else {
      // Apply listener on mount.
      document.addEventListener('focus', handleFocus, true);
    }
    // Remove listener when unmounting
    return () => {
      document.removeEventListener('focus', handleFocus, true);
    };
  }, [conditional]);
  return internalFocusRef;
};

export default useFocusOut;
